import { render, staticRenderFns } from "./HeaderBlackHoleStatusText.vue?vue&type=template&id=0cc13ba1&scoped=true&"
import script from "./HeaderBlackHoleStatusText.vue?vue&type=script&lang=js&"
export * from "./HeaderBlackHoleStatusText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc13ba1",
  null
  
)

export default component.exports